<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="reportBugForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group services-forms">
            <label class="sub-header-drpdown pb-2">Category *</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="accordion-text addScroll"
              #select
              [items]="categoryList"
              [searchable]="false"
              formControlName="category"
              bindLabel="name"
              placeholder="Category *"
              bindValue="id"
              [searchFn]="categorySearch"
              [virtualScroll]="true"
              groupBy="items"
              (change)="categoryObj($event)"
              [readonly]="existData ? true : false"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="select.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>

              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item?.name }}
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item?.name }}
                </div>
              </ng-template>
            </ng-select>

            <div
              *ngIf="submitted && reportBugForm.controls['category']?.invalid"
              class="input-error"
            >
              Please select category.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group textarea">
            <label class="sub-header-drpdown pb-2">Description *</label>
            <div class="services-form desc">
              <textarea
                formControlName="description"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                [readonly]="existData ? true : false"
              ></textarea>
            </div>
            <div
              class="input-error"
              *ngIf="submitted && reportBugForm.controls['description']?.invalid"
            >
              Description is required.
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentNote" class="info-text">
        {{ currentNote }}
      </div>
      <br />
      <div class="row">
        <div class="col-sm-6">
          <label class="sub-header-drpdown pb-2">{{
            existData
              ? 'Attachments'
              : 'Add your image or video
                        below'
          }}</label>
          <div *ngIf="!existData">
            <span class="input-text"
              >Select up to 5 items, with a maximum file size of 100MB per file</span
            >
          </div>
          <div class="fileinput fileinput-new mt-3" *ngIf="!existData">
            <div class="input-group input-large">
              <div
                class="form-control uneditable-input d-flex justify-content-flex-start align-items-center text-decoration-underline"
                data-trigger="fileinput"
              >
                <i class="fa fa-file fileinput-exists" *ngIf="isShowChange && isFileValid"></i>
                <span *ngIf="selectedFiles.length" class="fileinput-filename"
                  >{{ selectedFiles.length }} files selected</span
                >
                <span *ngIf="!selectedFiles.length" class="fileinput-filename">
                  <label class="input-center">Project images</label>
                </span>
              </div>
              <span class="btn default btn-file">
                <input
                  type="file"
                  #myFileInput
                  accept="image/png, image/jpg, image/jpeg, video/mp4, video/avi, video/mkv"
                  (change)="fileChangeEvent($event)"
                  multiple
                  style="display: none"
                  #hiddenfileinput
                />
                <button
                  style="padding: 0px; color: white; width: 140px !important; border-radius: 0px"
                  (click)="hiddenfileinput.click()"
                  class="waves-effect waves-light btn"
                >
                  Select files
                </button>
              </span>
              <button
                (click)="removeFiles()"
                *ngIf="selectedFiles.length"
                class="waves-effect waves-light btn removeBtn"
              >
                Remove all
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="fileUrls.length">
        <div
          class="form-group fileContainer mt-3"
          [ngClass]="{ 'pre-cross-img': selectedFiles, 'post-cross-img': !selectedFiles }"
        >
          <div *ngFor="let file of fileUrls; let i = index" class="image-container">
            <div class="row project-image-div" (click)="removeParticularFile(i)" *ngIf="!existData">
              <div class="cross-position">
                <img
                  src="./assets/icons/pop-up-cross.svg"
                  class="cross-icon"
                  width="15"
                  height="15"
                />
              </div>
            </div>
            <img
              *ngIf="file.type.startsWith('image/')"
              [src]="file.url"
              alt="Selected image"
              width="100"
              height="100"
              class="image-preview-img"
              (click)="onClick(file.url, 'image')"
            />
            <div (click)="onClick(file.url, 'video')">
              <video
                *ngIf="file.type.startsWith('video/')"
                width="100"
                height="100"
                controls
                class="video-preview"
              >
                <source [src]="file.url" type="{{ file.type }}" />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="existData && !fileUrls.length">
        <label class="sub-header-drpdown pb-2"
          >No image or video has been uploaded by the user</label
        >
      </div>

      <div *ngIf="!isFileValid || imageLimitExceeded || fileSizeExceeded">
        <span *ngIf="imageLimitExceeded" class="input-error"
          >You can only select up to 5 files. Additional files have been ignored.</span
        >
        <span *ngIf="fileSizeExceeded" class="input-error"
          >The maximum file size allowed is 100MB. Some files have been ignored.</span
        >
        <span *ngIf="!isFileValid" class="input-error"
          >Only .jpg, .png, .jpeg, .mp4, .avi, and .mkv files are allowed.</span
        >
      </div>
    </form>
  </div>
  <div class="modal-footer box-footer" *ngIf="!this.existData">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="isSubmitting"
      (click)="saveReportBug()"
    >
      Report issue
    </button>
  </div>
</div>
